import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import CardContentActionTile from "../../../common/components/CardContentActionTile/CardContentActionTile";
import { Box } from "@mui/system";
import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import ReviewTile from "../../../common/components/ReviewTile/ReviewTile";

interface propsType {
  trans?: any;
}
const ReviewsPresenter: React.FC<propsType> = ({ trans }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <div>
      <CustomEditCard
        card_title={trans("Reviews")}
        card_height="310px"
        showEditButton={false}
      >
        <Box style={{ marginBottom: "24px" }} />

        <div>
          <ReviewTile
            review_heading="Perfomance - Check in"
            review_value="85"
            date={new Date()}
          />
        </div>
      </CustomEditCard>

      {/* Add Employee Skill Modal */}
    </div>
  );
};

export default ReviewsPresenter;
